var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk0443430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116.5 30",
    style: {
      enableBackground: "new 0 0 116.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.2,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.6354 49.5917)",
    width: 28.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.8,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 33.3438 100.3517)",
    width: 1,
    height: 28.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1,30H87V0h30.1V30z M87.9,29h28.2V1H87.9V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,25.9H90.4V3.7h22.7V25.9z M91.4,24.9h20.8V4.7H91.4V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 5.2385 36.0008)",
    width: 28.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.9,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 18.8318 75.2923)",
    width: 1,
    height: 28.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2,30H58.1V0h30.1V30z M59,29h28.2V1H59V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2,25.9H61.5V3.7h22.7V25.9z M62.5,24.9h20.8V4.7H62.5V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.8074 22.2731)",
    width: 28.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.8,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 4.1793 49.9902)",
    width: 1,
    height: 28.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 11,
    width: 3.6,
    height: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H28.9V0H59V30z M29.9,29h28.2V1H29.9V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.3V3.7H55V25.9z M33.3,24.9h20.8V4.7H33.3V24.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.3,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -1.5895 8.682)",
    width: 28.6,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.9,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 -10.3328 24.9308)",
    width: 1,
    height: 28.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1,29h28.2V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2,25.9H3.4V3.7h22.7V25.9z M4.4,24.9h20.8V4.7H4.4V24.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk0443430);
export default __webpack_public_path__ + "static/media/AK0_4_4343_0.3520d5101a722c2503dfd7ee3e41476c.svg";
export { ForwardRef as ReactComponent };